import { styled } from 'styled-components';

export const Container = styled.div`
  padding: 0.5rem;

  @media print {
    display: none;
  }
`;
